/**
 * Маска российского телефона "+7 (___) ___-__-__" из произвольного ввода.
 */
export function formatPhone(raw) {
  let value = String(raw ?? '').replace(/\D/g, '');
  if (value.startsWith('8')) value = '7' + value.slice(1);
  if (value.length > 0 && !value.startsWith('7')) value = '7' + value;
  let out = '';
  if (value.length > 0) out = '+7';
  if (value.length > 1) out += ' (' + value.slice(1, 4);
  if (value.length > 4) out += ') ' + value.slice(4, 7);
  if (value.length > 7) out += '-' + value.slice(7, 9);
  if (value.length > 9) out += '-' + value.slice(9, 11);
  return out;
}

export function digitsOnly(value, maxLen = Infinity) {
  return String(value ?? '').replace(/\D/g, '').slice(0, maxLen);
}
